import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DynamicFormService } from '../dynamic-form/dynamic-form.service';
import {
  FieldConfig,
  IAlertConfig,
  Validator,
} from '../dynamic-form/dynamic-form-config.interface';
import { CustomValidators } from '../../validators/custom-validators';
import moment from 'moment';
import { Validators } from '@angular/forms';
import { IObject } from 'src/app/state/objects/objects.models';
import { ISelectProductOption } from './interfaces/productPriceComponent.interface';

@Injectable()
export class JsonConfiguration {
  translateKey: string = 'calculator';
  pre_selectedObject: IObject;

  minValue: number = 0;
  maxValue: number = 0;

  selectProduct: { options: ISelectProductOption[]; isMultiple: boolean } = {
    options: [],
    isMultiple: false,
  };

  constructor(
    private translateService: TranslateService,
    private dynamicFormService: DynamicFormService,
  ) {}

  generateProductField(pre_loaded_config: FieldConfig): FieldConfig {
    const inputName = 'typeOfProduct';
    const label = this.translateService.instant(
      `${this.translateKey}.input.${inputName}.label`
    );
    const productValidation =
      this.dynamicFormService.generateRequiredValidation(this.translateKey);

    return this.dynamicFormService.generateField(
      inputName,
      label,
      'autocomplete',
      null,
      null,
      '100%',
      [productValidation],
      { select: this.selectProduct, ...pre_loaded_config }
    );
  }

  generatePriceField(pre_loaded_config: FieldConfig): FieldConfig {
    const inputName = 'price';
    const label = this.translateService.instant(
      `${this.translateKey}.input.${inputName}.label`
    );
    const priceValidation = this.dynamicFormService.generateRequiredValidation(
      `${this.translateKey}.input.${inputName}`
    );
    const minValueValidation = this.generateMinValueValidation(this.minValue);
    const maxValueValidation = this.generateMaxValueValidation(this.maxValue);

    const validations = [
      priceValidation,
      minValueValidation,
      maxValueValidation,
    ];

    const additional_options: FieldConfig = {
      lang: 'es',
      isCurrency: true,
      ...pre_loaded_config,
    };

    const product_price =
      (this.pre_selectedObject &&
        this.pre_selectedObject.selectedProductPrice) ||
      0;

    return this.dynamicFormService.generateField(
      inputName,
      label,
      'input',
      null,
      product_price,
      '150px',
      validations,
      additional_options
    );
  }

  generateMinValueValidation(min): Validator {
    const minPrice = min;
    const key = this.translateKey + '.input.price.validations.min';
    const message = this.translateService.instant(key) as string;

    return {
      name: 'min',
      validator: Validators.min(minPrice),
      message: message + min + '€',
    };
  }

  generateMaxValueValidation(max): Validator {
    const maxPrice = max;
    const key = this.translateKey + '.input.price.validations.max';
    const message = this.translateService.instant(key) as string;

    return {
      name: 'max',
      validator: Validators.max(maxPrice),
      message: message + max + '€',
    };
  }

  /**
   * Generate FechaCompra field with validations and label
   * @returns The label generated
   */
  generate_fecha_compra_field(): FieldConfig {
    const max_date_diff = 5; // obtener del enviroment o de api, 5 = españa
    const input_name = 'buyDate';
    const alertFieldConfig: IAlertConfig = {
      active: true,
      title: '¡IMPORTANTE!',
      content:
        'El cliente deberá contar con la factura de su bici, ya que se le solicitará cuando comunique un siniestro.',
    };

    const required_validation = this.dynamicFormService.generateRequiredValidation(input_name);

    const validations = [required_validation];

    const label = this.generate_fecha_compra_label();
    const options: any = {
      alert: alertFieldConfig,
      dateConfig: { yearAndMonth: true },
    };

    const currentDate = new Date();

    if (!!max_date_diff) {
      const maxDate = moment();
      const minDate = maxDate
        .clone()
        .subtract(max_date_diff, 'year')
        .startOf('month');
      options.dateConfig.maxDate = maxDate.toDate();
      options.dateConfig.minDate = minDate.toDate();

      const diff_date_validation = this.generate_date_diff_validation(
        'before',
        max_date_diff
      );
      validations.push(diff_date_validation);
    }

    // return this.generate_field(input_name, label, "date", "MM/YYYY", "55%", validations, options);

    return this.dynamicFormService.generateField(
      input_name,
      label,
      'date',
      'MM/YYYY',
      currentDate,
      '55%',
      validations,
      options
    );
  }

  generate_date_diff_validation(
    before_or_after: 'before' | 'after',
    years: number
  ): Validator {
    const key = 'calculator.input.buyDate.validations.diffDateToNow';
    const message = this.translateService.instant(key) as string;

    return {
      name: 'diffDateToNow',
      validator: CustomValidators.diffDateToNow(before_or_after, years),
      message: message,
    };
  }

  generate_fecha_compra_label(): string {
    let key = `calculator.input.buyDate.label`;
    let label = this.translateService.instant(key) as string;
    return label;
  }
}
